import type { ReactNode } from 'react'
import { Button, DialogContentText } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { useTranslation } from 'react-i18next'
import ActionDialog from './ActionDialog'

interface ConfirmActionDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: ReactNode
  message: ReactNode
  confirmLabel: ReactNode
  pending?: boolean
}

const ConfirmActionDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  pending = false,
}: ConfirmActionDialogProps) => {
  const { t } = useTranslation()

  return (
    <ActionDialog
      open={open}
      onClose={onClose}
      title={title}
      pending={pending}
      actions={
        <>
          <Button
            type="button"
            variant="outlined"
            onClick={onClose}
            disabled={pending}
          >
            {t('cancel')}
          </Button>
          <LoadingButton
            type="button"
            variant="contained"
            onClick={onConfirm}
            loading={pending}
          >
            {confirmLabel}
          </LoadingButton>
        </>
      }
    >
      <DialogContentText>{message}</DialogContentText>
    </ActionDialog>
  )
}

export default ConfirmActionDialog
